// components
import { Head } from "components/molecules/Head/Head";
import SideNavigation from "components/organisms/SideNavigation/SideNavigation";
import Spinner from "components/atoms/Spinner/Spinner";
import RouteGuard from "app/hooks/RouteGuard";
import LandingPage from "containers/LandingPage/LandingPage";

// hook
import { useHome } from "containers/Home/useHome";

// modules
import styles from "containers/Home/Home.module.css";

// constants
import { PageTitles } from "constants/global";

export type HomeProps = {
	element?: React.ReactNode;
};

// Component
const Home = ({ element }: HomeProps): JSX.Element => {
	const componentProps = useHome();
	const {
		loading,
		open,
		outlets,
		userDetails,
		isAdminUser,
		isHomePage,
		menusToRender,
		activeMenu,
		handleMenuClick,
		handleToggle,
		handleUsernameClick,
		hasUserProfileViewPermission
	} = componentProps;

	if (loading) {
		return <Spinner />;
	}

	return (
		<div data-testid="home" className={styles.parentContainer}>
			<Head>{PageTitles.HOME}</Head>
			<div className="fixed z-10 w-min">
				<SideNavigation
					outlets={outlets}
					userDetails={userDetails}
					open={open}
					isAdminUser={isAdminUser}
					menusToRender={menusToRender}
					activeMenu={activeMenu}
					handleToggle={handleToggle}
					handleMenuClick={handleMenuClick}
					handleUsernameClick={handleUsernameClick}
					hasUserProfileViewPermission={hasUserProfileViewPermission}
				/>
			</div>
			<div className="ml-0 lg:ml-[17.375rem] w-full h-full">
				{isHomePage ? (
					<RouteGuard>
						<LandingPage />
					</RouteGuard>
				) : (
					<div className={styles.content}>{element}</div>
				)}
			</div>
		</div>
	);
};

export default Home;
